import { faReply } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  label: string;
  onClick: () => void;
};

export const CommentButton = ({ label, onClick }: Props) => (
  <button
    type="button"
    onClick={onClick}
    className="flex items-center justify-center gap-2 rounded-[10px] bg-[#EDE5FC] px-4 py-2 text-sm font-medium text-[#350584]"
  >
    <FontAwesomeIcon icon={faReply} className="text-base" />
    <span>{label}</span>
  </button>
);
